// import IframeLoader from "_platform/output/iframeloader.vue";
// import DsfStatsAuditFormulaForm from '../audit/formulaForm.vue';

let router = [
  {
    path: "/iframeloader/:state?",
    name: "iframeloader",
    component: () => import(/* webpackChunkName: "platform_pc_router_iframe" */ "_platform/output/iframeloader.vue"),
    meta: {
      title: ""
    },
    props: (route) => {
      // let src = decodeURIComponent(route.fullPath)
      return {
        src: route.query.src
      };
    }
  },
  {
    path: "/pc/audit/formula/form",
    meta: {
      title: "审核公式维护",
      needLogin: false,
      waterMark: false
    },
    component: () => import(/* webpackChunkName: "platform_pc_router_audit_editor" */ "../audit/formulaForm.vue")
  },
  {
    path: "/pc/aiCenterHome",
    meta: {
      title: "智能中心",
      needLogin: false,
      waterMark: false
    },
    component: () => import(/* webpackChunkName: "platform_pc_router_smart_center_home" */ "../views/smartCenterHome/index.vue")
  },
  {
    path: "/pc/form/history",
    meta: {
      title: "表单修改历史",
      needLogin: false,
      waterMark: false
    },
    component: () => import(/* webpackChunkName: "platform_pc_router_form_history" */ "../views/formHistory")
  },
  {
    path: "/pc/error401",
    meta: {
      title: "会话已过期",
      needLogin: false,
      waterMark: false
    },
    component: () => import(/* webpackChunkName: "platform_pc_router_error" */ "../views/Error401")
  },
  {
    path: "/pc/deleteForm",
    name: 'deleteForm',
    meta: {
      title: "删除后的表单提示页",
      needLogin: true
    },
    component: () => import(/* webpackChunkName: "platform_pc_router_error" */ "../views/deletedForm")
  
  },
  {
    path: "/pc/previewHome",
    name: 'previewHome',
    meta: {
      title: "预览菜单",
      needLogin: true
    },
    component: () => import(/* webpackChunkName: "platform_pc_router_preview_home" */ "../views/previewHome"),
  },
];

export default router;
